module.exports = __webpack_public_path__ + "img/lg_ring_r_o_0_0@3x.c7def9dd.png";